<script setup lang="ts">
// Overlay "Em breve" reutilizável: cobre o elemento pai (que precisa ser
// `relative`) com blur + cadeado, no mesmo estilo usado no card de níveis
// do dropdown do perfil. Usado pra travar pontos de entrada de features
// temporariamente desativadas sem removê-las da UI.
interface Props {
  // Classe(s) de border-radius pra casar com o container que está travando.
  rounded?: string;
  // Texto exibido abaixo do cadeado.
  label?: string;
  // Intensidade do desfoque (classe backdrop-blur do Tailwind).
  blur?: string;
  // Cor/opacidade do véu escuro por cima do conteúdo travado.
  bg?: string;
}

withDefaults(defineProps<Props>(), {
  rounded: 'rounded-[10px]',
  label: 'Em breve',
  blur: 'backdrop-blur-[6px]',
  bg: 'bg-black/30',
});
</script>

<template>
  <div
    aria-hidden="true"
    :class="[
      'absolute inset-0 z-20 flex flex-col items-center justify-center gap-1 select-none pointer-events-none',
      bg,
      blur,
      rounded,
    ]"
  >
    <NuxtIcon
      class="text-[18px] text-white"
      filled
      name="mini-games/locked"
    />
    <span class="text-white text-[12px] font-medium leading-[100%]">
      {{ label }}
    </span>
  </div>
</template>
